import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import translate from '../../libs/i18n';
import { examPerformanceNumbersShape } from '../../utils/propTypesShapes';

import { ExamResumeCardStyle } from './ExamResumeCardStyle';

const ExamResumeCard = ({ resume, title }) => {
  const language = useSelector((state) => state.settings.language);

  const [timeCourse, setTimeCourse] = useState('all');

  const getValueByTimeCourse = useMemo(() => {
    if (resume && resume.all && resume.all.total > 0 && timeCourse === 'all') {
      return resume.all.total;
    }

    if (
      resume &&
      resume.this_month &&
      resume.this_month.total > 0 &&
      timeCourse === 'month'
    ) {
      return resume.this_month.total;
    }

    if (
      resume &&
      resume.today &&
      resume.today.total > 0 &&
      timeCourse === 'today'
    ) {
      return resume.today.total;
    }

    return 0;
  }, [resume, timeCourse]);

  return (
    <ExamResumeCardStyle>
      <div className="exam-resume-card-title">{title}</div>
      <div className="time-course-control">
        <button
          type="button"
          className={`time-course-button${
            timeCourse === 'all' ? ' selected' : ''
          }`}
          disabled={timeCourse === 'all'}
          onClick={() => setTimeCourse('all')}
        >
          {translate('all', language)}
        </button>
        <button
          type="button"
          className={`time-course-button${
            timeCourse === 'month' ? ' selected' : ''
          }`}
          disabled={timeCourse === 'month'}
          onClick={() => setTimeCourse('month')}
        >
          {translate('thisMonth', language)}
        </button>
        <button
          type="button"
          className={`time-course-button${
            timeCourse === 'today' ? ' selected' : ''
          }`}
          disabled={timeCourse === 'today'}
          onClick={() => setTimeCourse('today')}
        >
          {translate('today', language)}
        </button>
      </div>
      <div className="exam-resume-value">{getValueByTimeCourse}</div>
    </ExamResumeCardStyle>
  );
};

ExamResumeCard.propTypes = {
  resume: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    examPerformanceNumbersShape,
  ]),
  title: PropTypes.string,
};

ExamResumeCard.defaultProps = {
  resume: null,
  title: '',
};

export default ExamResumeCard;
